import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UIRouterModule } from '@uirouter/angular';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { EdlPublicComponent } from "./public/edl-public.component";
import { EdlAuthenticatedNavigationComponent } from "./authenticated/edl-authenticated-navigation.component";
import {EdlPrintComponent} from './print/edl-print.component';
import {PipesModule} from '../pipes/pipes.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BannerModule, EdlAuthenticatedModule, EdlCommonDirectiveModule, EdlCommonPipesModule } from '@edl-development/edl-common';
import { AuthenticatedHeaderComponent } from './authenticated/authenticated-header/authenticated-header.component';
import { AuthenticatedComponent } from './authenticated/authenticated/authenticated.component';
import { ComplyDirectivesModule } from '../directives/comply-directives.module';
import { EdlCommonAuthenticationModule } from '@edl-development/edl-auth';

@NgModule({
    imports: [
        CommonModule,
        UIRouterModule,
        NgbModule,
        FormsModule,
        ReactiveFormsModule,
        EdlCommonDirectiveModule,
        ComplyDirectivesModule,
        EdlCommonPipesModule,
        PipesModule,
        BannerModule,
        EdlAuthenticatedModule,
        EdlCommonAuthenticationModule
    ],
    declarations: [
        AuthenticatedComponent,
        AuthenticatedHeaderComponent,
        EdlPublicComponent,
        EdlAuthenticatedNavigationComponent,
        EdlPrintComponent
    ]
})
export class LayoutModule { }
